import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

const CreateRequestRecurring = async (data) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/request-recurrings`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.post(url, data, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const UpdateRequestRecurring = async (id, data) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/request-recurrings/${id}`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.put(url, data, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const UpdatePartialRequestRecurring = async (id, data) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/request-recurrings/${id}`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.patch(url, data, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const PreviewRequestRecurring = async (data) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/requests/recurrings/preview`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.post(url, data, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const RequestRecurringService = {
  CreateRequestRecurring,
  UpdateRequestRecurring,
  UpdatePartialRequestRecurring,
  PreviewRequestRecurring,
};

export default RequestRecurringService;